<template>
  <div style="background: #FAF9F5;">
    <!-- Start blog-posts Area -->
    <section class="blog-posts-area section-padding">
      <div class="blog-top-box">
        <div class=" blog-top-box-content">
          <div class="container blog-top-box-content-tit">
            <h1>News</h1>
          </div>
        </div>
        <img src="http://en.sc.ruc.edu.cn/static/images/blog/png1.png" alt="">
      </div>
      <div class="container">
        <div class="row">
          <div class="col-lg-12 post-list blog-post-list">
            <div class="blog-list-item" @click="goTo('1')">
              <div class="row blog-list-item-box">
                <div class="col-lg-2 blog-list-item-box-lf">
                  <div class="blog-list-item-box-lf-tit">December</div>
                  <div class="blog-list-item-box-lf-day">24</div>
                </div>
                <div class="col-lg-8 blog-list-item-box-mid">
                  <h1>Suzhou Campus holds the inaugural Suzhou Forum...</h1>
                  <p>
                    The inaugural Suzhou Forum on Humanistic Economics and the unveiling ceremony of the Suzhou Research
                    Center for Humanistic Economics of Renmin University of China was held at the Suzhou campus on December
                    24, 2023.
                  </p>
                </div>
                <div class="col-lg-2 blog-list-item-box-rt">
                  <div>2023-12-24</div>
                </div>
              </div>
            </div>
            <div class="blog-list-item" @click="goTo('2')">

              <div class="row blog-list-item-box">
                <div class="col-lg-2 blog-list-item-box-lf">
                  <div class="blog-list-item-box-lf-tit">November</div>
                  <div class="blog-list-item-box-lf-day">20</div>
                </div>
                <div class="col-lg-8 blog-list-item-box-mid">
                  <h1>Suzhou Campus holds the Tenth Policy Forum in Asia</h1>
                  <p>
                    The Tenth Policy Forum in Asia was held at Suzhou Campus, with the theme: challenges and governance in
                    the digital age. Zhang Donggang, Chair of the University Council, Zheng Xinye, Vice President, as well
                    as Satoshi Nakano, President and Dun Yamada, Vice President of Ichibashi University, attended the forum.
                    Scholars from the two universities gave keynote speeches from different perspectives on opportunities and
                    challenges brought by digital transformation, conducting discussions on new trends of scientific research and
                    technological innovation in the digital age, changes in folk beliefs, local intangible cultural heritage customs
                    related to water, international governance of e-commerce, the American Industrial Chain Alliance, characteristics
                    of artificial intelligence and trust between human and machine.
                  </p>
                </div>
                <div class="col-lg-2 blog-list-item-box-rt">
                  <div>2023-11-20</div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End blog-posts Area -->
  </div>
</template>

<script>
  import router from '../router'

export default {
    methods: {
      goTo (id) {
        router.push({
          path: '/blogDetails',
          query: {
            id: id
          }
        })
      }
    }
  }
</script>
<style scoped lang="scss">
:root {
  --blog-list-item-hover: #333;
  --blog-list-item-rt-hover: #999;
}
.blog-post-list{
  padding-top: 40px;
}
.blog-posts-area{
  padding: 80px 0;
}

    .blog-list-item{
      padding: 40px 20px 32px 20px;
      background: #FFFFFF;
      margin-bottom: 10px;
      cursor: pointer;
    }

    .blog-list-item-box-lf{
      .blog-list-item-box-lf-tit{
        font-weight: 500;
        font-size: 28px;
        color: var(--blue);
        opacity: 0.6;
        margin-bottom: 2px;
        text-align: center;
      }
      .blog-list-item-box-lf-day{
        font-weight: bold;
        font-size: 36px;
        //color: #1168AB;
        color: var(--blue);
        opacity: 0.6;
        text-align: center;
      }

    }
    .blog-list-item-box-mid{
      h1{
        font-weight: normal;
        font-size: 20px;
        color: var(--blog-list-item-hover);
        line-height: 32px;
        text-transform: none;
      }
      h1:after{
        content: ' ';
        display: block;
        width: 30px;
        height: 2px;
        background: #096AD4;
        margin-top: 15px;
      }
      p{
        margin-top: 16px;
        font-weight: 400;
        font-size: 14px;
        color: var(--blog-list-item-hover);
        line-height: 26px;
        overflow: hidden;
        text-overflow: ellipsis;
        max-height: calc(3 * 24px); /* 3行的高度 */
        -webkit-line-clamp: 3; /* 最大行数 */
        -webkit-box-orient: vertical;
      }
    }
    .blog-list-item-box-rt{
      div{
        font-weight: 400;
        font-size: 13px;
        color: var(--blog-list-item-rt-hover);
      }
    }


.blog-list-item:hover{
  background-color: #8E3637;
  box-shadow: 0px 23px 29px 0px rgba(30,47,96,0.12);
  --blog-list-item-hover: #fff !important;
  --blog-list-item-rt-hover: #fff !important;
  --blue: #fff !important;
  background-image: url(http://en.sc.ruc.edu.cn/static/images/blog/png3.png);
  background-repeat: no-repeat;
  background-position: 100% 100%;
  background-blend-mode: overlay;
}
</style>



// WEBPACK FOOTER //
// BlogHome.vue?49b00845